import React from "react";
import { Link } from "gatsby";
import classNames from "classnames";
import { getLinkForPage } from "../../components/Blocks";
import { lookupColourString } from "../../lookups";

export interface RTFButtonLinkRendererProps {
  buttonText?: string | null;
  page?: Queries.LinkedPageFragment | null;
  externalLink?: string | null;
  className?: string;
  backgroundColor?: string | null;
  textColor?: string | null;
  locale?: string | null;
}

export const RTFButtonLinkRenderer: React.FC<RTFButtonLinkRendererProps> = ({
  buttonText,
  page,
  externalLink,
  backgroundColor,
  textColor,
  locale,
}) => {
  if (!buttonText) return null;

  const colorClasses = classNames(
    backgroundColor && lookupColourString(backgroundColor, "bg"),
    textColor && lookupColourString(textColor, "text")
  );

  const btnBaseClass =
    backgroundColor && textColor ? "genericButton" : "servicesButton";

  const btnClassName = classNames(
    btnBaseClass,
    "block w-fit !no-underline",
    colorClasses,
    "!font-medium"
  );

  if (page) {
    const internalPath = getLinkForPage(page);
    const prefix = `/${locale}`;
    const path = `${prefix}${internalPath}`;
    return (
      <Link title={buttonText} to={path} className={btnClassName}>
        {buttonText}
      </Link>
    );
  }

  if (externalLink) {
    return (
      <a
        href={externalLink}
        className={btnClassName}
        target="_blank"
        rel="noopener noreferrer"
        title={buttonText}
      >
        {buttonText}
      </a>
    );
  }

  return null;
};
